import { type FC } from 'react'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { CrossSellHorizontalSliderItemCompactImage } from './CrossSellHorizontalSliderItemCompactImage'
import { CrossSellHorizontalSliderItemCompactName } from './CrossSellHorizontalSliderItemCompactName'
import { CrossSellHorizontalSliderItemCompactPrice } from './CrossSellHorizontalSliderItemCompactPrice'
import { CrossSellHorizontalSliderItemCompactQuantity } from './CrossSellHorizontalSliderItemCompactQuantity'
import { CrossSellHorizontalSliderItemCompactRating } from './CrossSellHorizontalSliderItemCompactRating'
import { CrossSellHorizontalSliderItemCompactRedpointsMultiplier } from './CrossSellHorizontalSliderItemCompactRedpointsMultiplier'

type CrossSellHorizontalSliderItemCompactProps = {
  product?: CrossSellProduct
}

export const CrossSellHorizontalSliderCompactItem: FC<
  CrossSellHorizontalSliderItemCompactProps
> = ({ product }) => (
  <section
    className="relative mt-4 flex flex-1 flex-col rounded border border-dark-primary-min bg-light-primary-low"
    data-product-id={product?.id}
  >
    <CrossSellHorizontalSliderItemCompactRedpointsMultiplier
      product={product}
    />
    <CrossSellHorizontalSliderItemCompactImage product={product} />
    <div className="flex flex-1 flex-col items-start justify-start px-2.5 pt-2.5">
      <CrossSellHorizontalSliderItemCompactName product={product} />
      <CrossSellHorizontalSliderItemCompactQuantity product={product} />
      <CrossSellHorizontalSliderItemCompactRating product={product} />
      <CrossSellHorizontalSliderItemCompactPrice product={product} />
    </div>
  </section>
)
